/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const CloseIcon = props => {
	const { color = '' } = props
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			viewBox='0 0 21.349 21.45'
			{...props}
		>
			<path
				d='M12.307 10.724l8.747-8.96a1.043 1.043 0 00-.015-1.467 1.028 1.028 0 00-1.46.014l-8.731 8.946L1.755.297a1.028 1.028 0 00-1.46.014 1.043 1.043 0 00.014 1.467l9.079 8.946-9.08 8.946a1.043 1.043 0 00-.014 1.467 1.026 1.026 0 001.46.014l9.093-8.96 8.731 8.946a1.026 1.026 0 00.738.313 1.014 1.014 0 00.723-.3 1.042 1.042 0 00.015-1.467z'
				fill={color}
				fillRule='evenodd'
			/>
		</svg>
	)
}

export default CloseIcon
